import PropTypes from 'prop-types';
import { Box, CircularProgress, Divider, Typography, useTheme } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { useState, useEffect } from 'react';
import { CardViewTicket } from '../../components';
import TicketService from '../../services/tickets.service';

function ModalTicketsServicio({id, show, hideModal, items: itemsProp, servicioId}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [tickets, setTickets] = useState(itemsProp || []);
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();

    useEffect(() => {
        if(servicioId && (!itemsProp || itemsProp?.length === 0)){
            setIsLoading(true);
            TicketService.getByServicio(servicioId).then((resp) => {
                if(Array.isArray(resp)){
                    setTickets(resp || []);
                }else{
                    setTickets([]);
                }
            }).catch((err) => {
                console.log(err);
                setTickets([]);
            }).finally(() => {
                setIsLoading(false);
            });
        }
    }, [servicioId]);

    return (
        <Dialog open={show} disableEscapeKeyDown maxWidth='md' fullWidth className='side'>
            <Box sx={{background: isDarkMode ? '#1F2A40' : '#fff'}} className='side'>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Box sx={{display: 'flex', flexDirection: 'row',justifyContent:'start',alignItems:'center'}}>
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant='h5' component='div'>{`Servicio #${servicioId} - `}<Box fontWeight='normal' display='inline' sx={{color: isDarkMode ? '#b0bec5' : 'inherit'}}>{tickets?.[0]?.nombre_t || ''}</Box></Typography>
                    </Box>
                </DialogTitleDefault>
                <DialogContent className='side' sx={{background: isDarkMode ? '#1F2A40' : '#fff'}}>
                    {isLoading ? (
                        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4}}>
                            <CircularProgress size={36} />
                        </Box>
                    ) : tickets?.length > 0 ? (
                        tickets.map((tkI) => (
                            <CardViewTicket item={tkI} key={tkI?.id_tk} onCloseModal={handleClose} />
                        ))
                    ) : (
                        <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}>
                            <Typography sx={{color: isDarkMode ? '#b0bec5' : '#6b788e'}}>
                                No se encontraron tickets para este servicio.
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
            </Box>
        </Dialog>
    );
}

ModalTicketsServicio.propTypes = {
    show: PropTypes.bool
};

ModalTicketsServicio.defaultProps = {
    show: false
};

export default ModalTicketsServicio